<template>
  <div id="app">
    <div class="layout full-height">
      <Layout class="full-height">
        <Sider
          ref="side1"
          hide-trigger
          collapsible
          :width="250"
          :collapsed-width="78"
          v-model="isCollapsed"
        >
          <AppMenu :class="menuitemClasses" />
        </Sider>
        <Layout>
          <AppHeader :style="{ padding: 0 }" class="layout-header-bar">
            <template v-slot:icon>
              <icon
                @click.native="collapsedSider"
                :class="rotateIcon"
                :style="{ margin: '0 20px' }"
                type="md-menu"
                size="24"
              ></icon>
            </template>
          </AppHeader>

          <Content :style="{ margin: '20px' }">
            <router-view />
          </Content>
          <AppFooter />
        </Layout>
      </Layout>
    </div>
  </div>
</template>

<script>
import AppMenu from "../Layout/AppMenu";
import AppHeader from "../Layout/AppHeader";
import AppFooter from "../Layout/AppFooter";

export default {
  data() {
    return {
      isCollapsed: false
    };
  },
  components: {
    AppMenu,
    AppHeader,
    AppFooter
  },
  computed: {
    rotateIcon() {
      return ["menu-icon", this.isCollapsed ? "rotate-icon" : ""];
    },
    menuitemClasses() {
      return ["menu-item", this.isCollapsed ? "collapsed-menu" : ""];
    }
  },
  methods: {
    collapsedSider() {
      this.$refs.side1.toggleCollapse();
    }
  }
};
</script>

<style scoped>
#app {
  height: 100vh;
}
.layout {
  border: 1px solid #d7dde4;
  background: #f5f7f9;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
}
.layout-header-bar {
  background: #fff;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}
.menu-icon {
  transition: all 0.3s;
}
.rotate-icon {
  transform: rotate(-90deg);
}
</style>
